module.exports = __webpack_public_path__ + "static/img/2705_phase_function_Paper_Points.da9896c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2705_phase_function_Paper_Points.png
// module id = kldk
// module chunks = 0